import { render, staticRenderFns } from "./CourseDocumentFrom.vue?vue&type=template&id=7b14a59f&"
import script from "./CourseDocumentFrom.vue?vue&type=script&lang=ts&"
export * from "./CourseDocumentFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports